<template>
  <transition name="slide-fade-up">
    <div class="Swiper">
      <img class="faux-background" src="../assets/main_bg.png" :class="{ 'is-visible':hasBackground }" />

      <router-link class="close" :to="{ name: 'Home' }"></router-link>

      <swiper :options="swiperOptions" ref="mySwiper">
        <swiper-slide v-for="(slide, index) in preppedSlides" :key="index">
          <div class="actual-slide">
            <div :style="{ 'background-image':'url('+slide.background+')' }">
              <img class="replay" src="../assets/replay.png" v-if="slide.video && slide.videoHasEnded" @click="replayVideo(index)"/>
              <video v-if="slide.video" :ref="'video_'+index" :src="slide.video"></video>
            </div>
          </div>
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
    </div>
  </transition>
</template>

<script>
  import { swiper, swiperSlide } from 'vue-awesome-swiper'
  import 'swiper/dist/css/swiper.css'

  export default {
    name: 'Swiper',

    props: ['slides'],

    components: {
      swiper,
      swiperSlide
    },

    data () {
      return {
        previousSlide: 0,
        preppedSlides: null,
        hasBackground: false,
        swiperOptions: {
          pagination: {
            el: '.swiper-pagination'
          }
        }
      }
    },

    computed: {
      swiper () {
        return this.$refs.mySwiper.swiper
      }
    },

    methods: {
      changeSlide () {
        // this.previousSlide = this.swiper.activeIndex // ??

        // show background if not on first or last slide
        this.hasBackground = this.swiper.activeIndex > 0 && this.swiper.activeIndex < this.slides.length - 1

        // check if slide contains a video, play it if it does
        if (this.preppedSlides[this.swiper.activeIndex].video) {
          this.preppedSlides[this.swiper.activeIndex].videoRef.play()
        }

        // stop and reset all videos for other slides, and hide the replay buttons
        this.preppedSlides.forEach((el, index) => {
          if (el.video && index !== this.swiper.activeIndex) {
            el.videoRef.pause()
            el.videoRef.currentTime = 0
            el.videoHasEnded = false
          }
        })
      },

      replayVideo (videoIndex) {
        this.preppedSlides[videoIndex].videoRef.currentTime = 0
        this.preppedSlides[videoIndex].videoRef.play()
        this.preppedSlides[videoIndex].videoHasEnded = false
      }
    },

    created () {
      // redirect to the home page if there are no props passed (user directly went to the Swiper url, or refreshed the page)
      if (!this.slides) {
        this.$router.push({ name: 'Home' })
      } else {
        // prep the background and video paths
        this.preppedSlides = this.slides.map((el, index) => {
          return {
            background: require('../assets/' + el.background),
            video: el.video ? require('../assets/' + el.video) : null,
            videoHasEnded: false
          }
        })
      }
    },

    mounted () {
      if (this.preppedSlides && this.swiper) {
        // we need to go through the prepped slides again to map video refs to (now existing) dom elements and add ending events
        this.preppedSlides.forEach((el, index) => {
          if (el.video) {
            el.videoRef = this.$refs['video_' + index][0]

            el.videoRef.onended = () => {
              el.videoHasEnded = true
            }
          }
        })

        // update the background as the active slide changes
        // also, pause/rewind the videos for previous slides
        this.changeSlide()
        this.swiper.on('slideChange', this.changeSlide)
      }
    }
  }
</script>

<style lang="scss">
  .Swiper {
    &.slide-fade-up-enter-active {
      transition: all .5s ease;
    }

    &.slide-fade-up-enter {
      transform: translateY(100px);
      opacity: 0;
    }

    .faux-background {
      display: block;
      position: absolute;
      width: 100%;
      height: 100%;
      z-index: 10;
      opacity: 0;
      transition: all 300ms ease-in-out;

      &.is-visible {
        opacity: 1;
      }
    }

    .close {
      display: block;
      position: absolute;
      top: 50px;
      right: 50px;
      width: 90px;
      height: 90px;
      z-index: 100;
    }

    .swiper-container {
      height: 100%;
      z-index: 20;

      video {
        position: absolute;
        top: 70px;
        left: 48px;
        z-index: 100;
        width: 1173px;
        height: 702px;
        object-fit: cover;
        background-color: black;
      }

      .replay {
        position: absolute;
        width: 150px;
        height: 150px;
        top: calc(50% - 50px);
        left: 50%;
        transform: translate(-50%, -50%) translate3d(0,0,0);
        z-index: 200;
      }

      .swiper-wrapper {
        height: 100%;

        .swiper-slide {
          height: 100%;

          > div {
            height: 100%;
            width: 100%;
            padding: 50px;

            > div {
              height: 100%;
              width: 100%;
              background-size: cover;
              position: relative;
            }
          }
        }
      }

      .swiper-pagination {
        bottom: 18px;
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/Swiper.vue